import { ContactSlugEnum } from '../enums/contact-fields-enum'
import { LocoAssetsKeysType } from '../i18next/types/loco-assets-keys-type'

export const contactFieldLocoKeys: Record<ContactSlugEnum, LocoAssetsKeysType> =
  {
    [ContactSlugEnum.Email]: 'core.contact_slug.email',
    [ContactSlugEnum.FirstName]: 'core.contact_slug.first_name',
    [ContactSlugEnum.Surname]: 'core.contact_slug.last_name',
    [ContactSlugEnum.PhoneNumber]: 'core.contact_slug.phone_number',
    [ContactSlugEnum.Country]: 'core.contact_slug.country',
    [ContactSlugEnum.Neighborhood]: 'core.contact_slug.neighborhood',
    [ContactSlugEnum.StreetAddress]: 'core.contact_slug.street_address',
    [ContactSlugEnum.StreetNumber]: 'core.contact_slug.street_number',
    [ContactSlugEnum.City]: 'core.contact_slug.city',
    [ContactSlugEnum.Postcode]: 'core.contact_slug.postal_code',
    [ContactSlugEnum.CompanyName]: 'core.contact_slug.company_name',
    [ContactSlugEnum.TaxNumber]: 'core.contact_slug.tax_number',
    [ContactSlugEnum.State]: 'core.contact_slug.state_province',
  }
